export default "<div class=\"spinner\">\r\n    <div class=\"cube1\"></div>\r\n    <div class=\"cube2\"></div>\r\n  </div>"